import { FieldDef } from "@synota-io/synota-shared-ui";
import { Chip } from "@mui/material";
import { PaymentMethodBluePenguinStatus } from "@synota-io/synota-shared-ui";
import { components } from "../../../api/generated-types";

type IBluePenguinUser = components["schemas"]["BluePenguinUserView"];

const BP_STATUS_COLOR_MAP: Record<
  PaymentMethodBluePenguinStatus | string,
  "success" | "info" | undefined
> = {
  "In implementation": "info",
  Active: "success",
  Prospect: "info",
  Submitted: "success",
};

export const bluePenguinUsersFields: FieldDef<IBluePenguinUser>[] = [
  {
    field: "synota_email",
    headerName: "Customer Email",
    minWidth: 200,
    displayTags: ["table"],
  },
  {
    field: "customer_name",
    headerName: "Customer Name",
    minWidth: 200,
    displayTags: ["table"],
    valueFormatter: (value) => value || "N/A",
  },
  {
    field: "bp_customer_id",
    headerName: "Customer ID",
    minWidth: 150,
    displayTags: ["table"],
  },
  {
    field: "sandbox",
    headerName: "Environment",
    minWidth: 120,
    displayTags: ["table"],
    renderCell: ({ row }) => (
      <Chip
        size="small"
        variant="outlined"
        color={row.sandbox ? "secondary" : "primary"}
        label={row.sandbox ? "Sandbox" : "Prod"}
      />
    ),
  },
  {
    field: "customer_status",
    headerName: "Status",
    minWidth: 150,
    displayTags: ["table"],
    renderCell: ({ row }) => (
      <Chip
        size="small"
        color={BP_STATUS_COLOR_MAP[row.customer_status || ""] || undefined}
        label={row.customer_status || "Unknown"}
      />
    ),
  },
  {
    field: "ach_account_mask",
    headerName: "ACH Account #",
    minWidth: 150,
    displayTags: ["table"],
    valueFormatter: (value) => value || "N/A",
  },
  {
    field: "ach_routing_mask",
    headerName: "ACH Routing #",
    minWidth: 150,
    displayTags: ["table"],
    valueFormatter: (value) => value || "N/A",
  },
];
